// Shared color palette for chart overlays and UI elements
// Used by TradingView chart overlays and trades table checkboxes

export const OVERLAY_COLORS = [
  '#FF9800', // Orange
  '#4CAF50', // Green
  '#F44336', // Red
  '#00BCD4', // Cyan
  '#E91E63', // Pink
  '#9C27B0', // Purple
];

// Default color for TradingView Line Plots
export const MATERIAL_BLUE = '#2196F3';

export const getOverlayColor = (index: number): string => {
  return OVERLAY_COLORS[index % OVERLAY_COLORS.length];
};
